import React from "react";
import { useState } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, FormGroup, Input, ListGroup, ListGroupItem, Row } from "reactstrap";

const PDScreenTwo = (props)=>{
    const [stepFormCur, setStepFormCur] = useState(0);
    return (
        <><CardBody className={`nex-form-step ${stepFormCur == 0 ? 'active' : ''}`}>
        <br/>
        <br/>
        <div className="nex-form-field-container">
        <div className="nex-form-group nex-content-center">
            <div className="nex-form-group-c">
            <label htmlFor="" className="nex-big-label">Choose  patient through bellow lists for second opinion.</label>
                <Row>
                    <Col lg={6}>
                        <FormGroup>
                            <Input placeholder="Name"></Input>
                        </FormGroup>
                    </Col>
                    <Col lg={6}>
                        <FormGroup>
                            <Input placeholder="Age"></Input>
                        </FormGroup>
                    </Col>
                    <Col lg={6}>
                        <FormGroup>
                            <Input placeholder="Email"></Input>
                        </FormGroup>
                    </Col>
                    <Col lg={6}>
                        <FormGroup>
                            <Input placeholder="Phone"></Input>
                        </FormGroup>
                    </Col>
                    <Col lg={12} className="action d-flex justify-content-center">
                    <Button
                                    color="primary"
                                    className="nexogic_primary_button"
                                    onClick={(e)=>props.goto(e, 4)}
                                >
                                    Next
                                </Button>
                    </Col>
                    <div className="nex-or-txt">
                        Or
                    </div>

                    <Col lg={12}>
                        <FormGroup>
                            <Input type="select"  onChange={(e)=>props.goto(e, 3)}>
                                <option>
                                    Select form lists
                                </option>
                                <option>
                                    option 1
                                </option>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>

            
            </div>
        </div>
        </div>
        <div className="nex-form-group-c mb-2">
        <div className="nex-form-action">
            <Button
                color="primary"
                className="nexogic_primary_button_outline"
                onClick={(e)=>props.goBack(e, 1)}
            >
                Back
            </Button>
        </div>
        </div>


    </CardBody></>
    )
}
export default PDScreenTwo;